<template>
  <woot-modal :show="show" :on-close="closeModal">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.TITLE')"
      />

      <form class="mx-0 flex flex-wrap w-full" @submit.prevent="submit">
        <dynamic-content
          class="w-full flex justify-center"
          description-key="doc_signature_usage_description"
        />
        <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
          <woot-button
            type="submit"
            :is-loading="isSubmitting"
            :is-disabled="uiFlags.isFetching"
            color-scheme="success"
            class="button nice"
          >
            {{ $t('INTEGRATION_APPS.CUSTOM_TEXTS.DOC_SIGNATURE.CONNECT.BUTTON_TEXT') }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onDismiss">
            {{ $t('INTEGRATION_SETTINGS.DASHBOARD_APPS.CREATE.FORM_CANCEL') }}
          </woot-button>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import DynamicContent from '../../../routes/dashboard/dynamicContent/Index.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    DynamicContent,
  },
  mixins: [alertMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'online99Extra/getUIFlags',
    }),
  },
  methods: {
    onDismiss() {
      this.showAlert(
        this.$t('INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.DISMISS_MESSAGE')
      );
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
    async submit() {
      this.isSubmitting = true;
      try {
        await this.enableDocSignature();
        this.closeModal();
      } catch (err) {
        // error handled in enableDocSignature
      } finally {
        this.isSubmitting = false;
      }
    },
    async enableDocSignature() {
      let alertMessage;
      const payload = {
        app_id: 'doc_signature',
        settings: {},
      };
      try {
        await this.$store.dispatch('integrations/createHook', payload);
        await this.$store.dispatch('accounts/update', {
          additional_attributes: { document_signature_enabled: true },
        });
        alertMessage = this.$t(
          'INTEGRATION_SETTINGS.DOCAL.CTA_MODAL.SUCCESS_MESSAGE'
        );
      } catch (error) {
        console.error(error);
        const errorMessage = error?.response?.data?.message;
        alertMessage =
          errorMessage || this.$t('INTEGRATION_APPS.ADD.API.ERROR_MESSAGE');
        throw error;
      } finally {
        this.showAlert(alertMessage);
      }
    },
  },
};
</script>
